<template>
  <div class="club-page mt-4">
    <app-page-header title="Informações"></app-page-header>

    <section>
      <h1>O Clube</h1>
      <p>
        O clube de benefícios “CLUBE VENDA E GANHE”, é uma ação de
        relacionamento e incentivo da marca Philco para as equipes de vendas das
        empresas revendedoras, com o objetivo de desenvolver um relacionamento
        duradouro.
        <br />
        <br />O Clube Venda e Ganhe, visa premiar as equipes de vendas, das
        empresas revendedoras, através do sistema de pontos, pela venda dos
        produtos constantes neste programa. Estes pontos adquiridos, poderão ser
        utilizados no resgate de produtos ou serviços, disponibilizados na
        plataforma do programa.
        <br />
        <br />Além de acumular pontos e trocar por produtos ou serviços, os
        participantes terão acesso a conteúdo exclusivo, informações sobre
        produtos, lançamentos e treinamentos.
      </p>
    </section>

    <section>
      <h1>Como funciona</h1>
      <div class="info-cards">
        <info-card
          v-for="(info, index) in cards"
          :key="index"
          :text="info.text"
          :image="info.image"
        ></info-card>
      </div>
    </section>

    <section>
      <div class="about-philco">
        <img src="@/assets/img/philco_white.svg" alt="Logo Philco" />
          <p>
            A Philco chegou no Brasil em 1934, há quase cem anos. Na época, se
            consolidou no mercado brasileiro sendo referência em rádios, TVs, câmeras e
            vídeo cassetes.
          <br />
          <br />  Com décadas de experiência e atuação no mercado, conquistamos a confiança
            de todo o país. Hoje, somos uma marca 100% nacional e consolidados em
            diversas outras categorias também, como Áudio, Vídeo, Eletrodomésticos,
            Eletroportáteis, Cuidados pessoais, Ferramentas, Climatização e muito mais.
          <br />
          <br />  Mais que um grande portfólio, ter uma relação de confiança com nossos
            consumidores, clientes e parceiros é extremamente importante para a nossa
            marca. Atuamos em áreas de impacto na sociedade, apoiando a cultura e
            grandes eventos esportivos.
          <br />
          <br />  Fazemos negócios apenas com o que há de melhor em tecnologia, design e
            durabilidade, e por isso nossos produtos estão presentes nas prateleiras do
            Brasil inteiro, em lojas físicas e online.
          <br />
          <br />  Nossa missão é estar sempre a frente, trazendo o que há de mais inovador
            para o mercado e construindo uma história cada vez mais forte com o
            consumidor brasileiro.
          <br />
          <br /> Tem coisas que só a Philco faz pra você.
          </p>
      </div>
    </section>
  </div>
</template>

<script>
import InfoCard from '@/components/ClubPage/InfoCard.vue';

export default {
  name: 'club-page',
  components: {
    InfoCard,
  },
  data: () => {
    return {
      cards: [
        {
          image: require('@/assets/img/cfc-01.png'),
          text: 'Você vende os produtos participantes e acumula pontos!',
        },
        {
          image: require('@/assets/img/cfc-02.png'),
          text:
            'Quanto mais você vende, mais pontos ganha e pode consultar quando quiser.',
        },
        {
          image: require('@/assets/img/cfc-03.png'),
          text:
            'Seus pontos podem ser trocados por dinheiro ou produtos Philco.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
section {
  padding: 32px;
  max-width: 60vw;
  margin: auto;
  text-align: center;

  img {
    fill: #fff;
  }

  h1 {
    font-family: var(--font-family-secondary);
    font-size: 1.4em;
    font-weight: bold;
    margin-bottom: 24px;
  }

  &:not(:last-child) {
    border-bottom: 2px solid #e2e2e2;
  }
}

.info-cards {
  display: flex;
  align-content: center;
  justify-content: center;

  .info-card {
    display: inline-block;
    margin: 0 16px;
  }
}

.about-philco {
  padding: 32px;
  background: #000;
  color: #fff;
  border-radius: 8px;
  text-align: center;
  max-width: 600px;
  margin: auto;

  img {
    margin-bottom: 32px;
  }
}

@media (max-width: 1366px) {
  section {
    max-width: 80vw;
  }
}

@media (max-width: 992px) {
  section {
    max-width: 90vw;
  }

  div.info-cards {
    flex-wrap: wrap;

    .info-card {
      flex: 0 100%;
      margin-bottom: 16px;
    }
  }
}
</style>
